import AlertContainer from "./AlertContainer.vue";
import { AlertBus } from "./AlertBus";

declare module "vue/types/vue" {
  export interface Vue {
    $alerts: AlertTypes;
  }
}

export type AlertTypes = {
  success: Function;
  danger: Function;
  confirm: Function;
  warn: Function;
};

export type AlertEvent = {
  type: string;
  resolve: Function;
  message: string;
  messageCookies?: any;
};

export default function install(Vue: any) {
  Object.defineProperty(Vue.prototype, "$alerts", {
    get() {
      return Alerts;
    }
  });

  Vue.component("AlertContainer", AlertContainer);
}

const Alerts: AlertTypes = {
  danger(message: string): Promise<string> {
    return buildPromise(message, "danger");
  },
  success(message: string): Promise<string> {
    return buildPromise(message, "success");
  },
  confirm(question: string, messageCookies?: any): Promise<string> {
    return buildPromise(question, "confirm", messageCookies);
  },
  warn(message: string): Promise<string> {
    return buildPromise(message, "confirm");
  }
};

function buildPromise(message: string, type: string, messageCookies?: any) {
  const promise = new Promise<string>(resolve => {
    AlertBus.$emit(type, {
      type,
      resolve,
      message,
      messageCookies
    } as AlertEvent);
  });
  return promise;
}
